import $ from 'jquery';
import 'owl.carousel';
import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";
import 'bootstrap';